<template>
    <transition name="fade-transform" mode="out-in">
        <keep-alive :exclude="notCacheName">
            <router-view/>
        </keep-alive>
    </transition>
</template>
<script>
    export default {
        name: 'ParentView',
        computed: {
            notCacheName() {
                return (this.$route.meta && this.$route.meta.notCache) ? this.$route.name : ''
            }
        }
    }
</script>
<style scoped lang="less">
    .fade-transform-leave-active,
    .fade-transform-enter-active {
        transition: all .5s;
    }

    .fade-transform-enter {
        opacity: 0;
        transform: translateX(-30px);
    }

    .fade-transform-leave-to {
        opacity: 0;
        transform: translateX(30px);
    }
</style>